import {createContext, useContext, useState, useEffect} from 'react';
import {getLocaleFromUrl} from '../utils/locale-from-url';

const LocaleContext = createContext();

const LocaleProvider = ({children}) => {
  const [locale, setLocale] = useState(getLocaleFromUrl() || localStorage.getItem('locale') || 'en');

  useEffect(() => {
    localStorage.setItem('locale', locale);
  }, [locale]);

  const setNewLocale = (newLocale) => {
    setLocale(newLocale);
    window.location.reload();
  };
  const contextValue = {
    locale,
    setLocale: setNewLocale,
  };

  return <LocaleContext.Provider value={contextValue}>{children}</LocaleContext.Provider>;
};

const useLocale = () => {
  const {locale, setLocale} = useContext(LocaleContext);

  return {locale, setLocale};
};

export {LocaleProvider, useLocale};
